import Vue from "vue";
import VueRouter from "vue-router";

// import { auth } from "@/common/firebase.js";
import store from "@/store/index.js";
//static components/views
import LoginView from "@/views/Login.vue";

//lazy loading viewvs
function lazyLoadView(view) {
  return () => import(`@/views/${view}.vue`);
}

//lazy load admin tools
const create = () => {
  return import("@/components/admin/CreateAssessment.vue");
};

//lazy load admin tools
const firebaseLogin = () => {
  return import("@/components/admin/FirebaseLogin.vue");
};

// lazy load assessment view + skill + level components
const assessment = () => {
  return import(/* webpackChunkName: "assessment" */ "@/views/Assessment.vue");
};
const skill = () => {
  return import(
    /* webpackChunkName: "assessment" */ "@/components/assessment/Skill.vue"
  );
};
const level = () => {
  return import(
    /* webpackChunkName: "assessment" */ "@/components/assessment/Level.vue"
  );
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: lazyLoadView("Home")
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView
  },
  {
    path: "/Assessment/:tool",
    name: "Assessment",
    component: assessment,
    props: true,
    children: [
      {
        path: ":skill",
        component: skill,
        children: [{ path: ":level", component: level }]
      }
    ]
  },
  {
    path: "/profile",
    component: lazyLoadView("Profile")
  },
  {
    path: "/admin",
    component: lazyLoadView("Admin"),
    children: [
      {
        path: "create",
        component: create
      },
      {
        path: "firebase-login",
        component: firebaseLogin
      }
    ]
  },
  {
    path: "*",
    name: "404",
    component: lazyLoadView("404")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(async (to, from, next) => {
  if(!store.getters["user/GET_USER"] && localStorage.getItem('user-token')) {
    await store.dispatch('user/USER_REQUEST')
  }
  if (to.name !== "Login") {
    if (store.getters["user/GET_USER"]) {
      const assessments = store.getters["user/GET_AVAILABLE_ASSESSMENT"];
      if (
        to.name === "Assessment" &&
        (assessments.D1 < 1 && assessments.D3 < 1)
      ) {
        
        if(store.getters["user/IS_ADMIN"]) {
          next();
        } else {
          next("/");
        }
      } else {
        next();
      }
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

export default router;
